// extracted by mini-css-extract-plugin
export default {"pageLayout":"Staff_pageLayout__Pm7dt"};